module.exports = __webpack_public_path__ + "static/media/1033165.b02061dc.jpg";